import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseMultiControl } from 'shared/abstract/base-multi-control';
import { ClickOutsideDirective } from 'shared/directives/click-outside.directive';
import { ListItem } from 'shared/interfaces/list-item';
import { HighlightPipe } from 'shared/pipes/highlight.pipe';
import { ModalService } from 'shared/services';

@Component({
    selector: 'app-multi-select-input',
    templateUrl: './multi-select-input.component.html',
    styleUrls: ['./multi-select-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiSelectInputComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, NgClass, AsyncPipe, ClickOutsideDirective, TranslateModule, HighlightPipe],
})
export class MultiSelectInputComponent extends BaseMultiControl implements ControlValueAccessor, OnInit, OnDestroy {
    constructor(modalService: ModalService, changeDetectorRef: ChangeDetectorRef, translate: TranslateService) {
        super(modalService, changeDetectorRef, translate);
    }

    public selectOption(option: ListItem, emitEvent = true, event: Event | null = null) {
        if (option) {
            if (this.selectedOptions.findIndex((selected) => selected.id === option.id) === -1) {
                this.selectedOptions.push(option);
            }

            this.closeOptionsList();
            this.updateAvailableOptionsList();
            this.form.get('searchInput')?.setValue(undefined);

            if (emitEvent) {
                this.onChangeFunction(this.selectedOptions.map((opt) => opt.id));
                this.change.emit(this.selectedOptions.map((opt) => opt.id));
                this.multiSelectInput?.first?.nativeElement?.focus();
                event?.preventDefault();
                event?.stopPropagation();
            }
        }
    }

    public onEnterKey(event: any) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isOptionsListVisible()) {
            if (this.selectedIndex === -1) {
                this.closeOptionsList();
                return;
            }

            const element = this.filteredAvailableOptionsList[this.selectedIndex];

            if (this.filteredAvailableOptionsList?.length > this.selectedIndex && !this.selectedOptions.includes(element)) {
                this.selectOption(element);
            }
        } else {
            this.openOptionsList();
        }
    }
}
